module.exports = __webpack_public_path__ + "img/avatar-gender-w-s.4e3c932a.png";